import { ChangeCategoryAction } from '../reducers/CategoryReducer';

export type CategoryAction = 'CHANGE_CATEGORY';

export const changeCategory = (payload: ChangeCategoryAction | undefined) => ({ type: 'CHANGE_CATEGORY', payload });
